import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import { Overlay } from 'react-bootstrap'

interface InfoPopoverProps {
    children: ReactNode
    popoverContent: ReactNode
    placement?: 'top' | 'right' | 'bottom' | 'left'
    iconClassName?: string
    backgroundColor?: string
}

const InfoPopover: FC<InfoPopoverProps> = ({
    children,
    popoverContent,
    placement = 'right',
    iconClassName = 'bi bi-info-circle text-danger cursor-pointer',
    backgroundColor = 'red'
}) => {
    const iconRef = useRef<HTMLElement | null>(null)
    const containerRef = useRef<HTMLSpanElement | null>(null)
    const [show, setShow] = useState(false)

    const toggle = () => setShow((prev) => !prev)
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target as Node)
            ) {
                setShow(false)
            }
        }

        const handleScroll = () => {
            setShow(false)
        }

        if (show) {
            document.addEventListener('mousedown', handleClickOutside)
            window.addEventListener('scroll', handleScroll, true)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', handleScroll, true)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', handleScroll, true)
        }
    }, [show])
    return (
        <span ref={containerRef} className="d-inline-flex align-items-center gap-2">
            {children}
            <i
                className={iconClassName}
                ref={(el) => (iconRef.current = el)}
                onClick={toggle}
            />
            <Overlay target={iconRef.current} show={show} placement={placement}>
                {(props) => (
                    <div
                        {...props}
                        style={{
                            position: 'absolute',
                            backgroundColor: backgroundColor,
                            padding: '4px 12px',
                            color: 'white',
                            borderRadius: 4,
                            maxWidth: 250,
                            zIndex: 1000,
                            marginLeft: 5,
                            ...props.style,
                        }}
                    >
                        {popoverContent}
                    </div>
                )}
            </Overlay>
        </span>
    )
}

export default InfoPopover